import { Box } from '#app/components/Box.js';
import PageTitle from '#app/components/PageTitle.js';
import '#app/styles/privacy.scss'; // CSS is generated from Google Docs xD

export default function PrivacyRoute() {
  return (
    <main className="container mx-auto mb-32">
      <div className="mx-auto flex w-full flex-col gap-4 pt-20 sm:px-20 md:px-32">
        <PageTitle title="Privacy Policy" />

        {/* HTML generated by Google Docs, don't judge. Try to do this per paragraph >:( */}
        <Box className="privacy flex flex-col gap-2">
          <p className="c91">
            <span className="c8">This privacy notice for </span>
            <span className="c34">Proven Valor </span>
            <span className="c8">&nbsp;(&quot;</span>
            <span className="c10">we</span>
            <span className="c8">,&quot; &quot;</span>
            <span className="c10">us</span>
            <span className="c8">,&quot; or &quot;</span>
            <span className="c10">our</span>
            <span className="c8">
              &quot;), describes how and why we might collect, store, use, and/or share (&quot;
            </span>
            <span className="c10">process</span>
            <span className="c8">&quot;) your information when you use our services (&quot;</span>
            <span className="c10">Services</span>
            <span className="c8">&quot;), such as when you: </span>
          </p>
          <ul className="c18 lst-kix_inusbfblagxh-0 start">
            <li className="c37 li-bullet-0">
              <span className="c8">
                Visit our website at example.com, or any website of ours that links to this privacy notice
              </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">
                Download and use our mobile application (PV-VHA), or any other application of ours that links to this
                privacy notice
              </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">
                Engage with us in other related ways, including any sales, marketing, or events
              </span>
            </li>
          </ul>
          <p className="c51">
            <span className="c10">Questions or concerns? </span>
            <span className="c8">
              Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree
              with our policies and practices, please do not use our Services.
            </span>
          </p>
          <p className="c41">
            <span className="c0">SUMMARY OF KEY POINTS </span>
          </p>
          <p className="c115 c158">
            <span className="c4">
              This summary provides key points from our privacy notice, but you can find out more details about any of
              these topics by clicking the link following each key point or by using our{' '}
            </span>
            <span className="c38">table of contents </span>
            <span className="c4">below to find the section you are looking for. </span>
          </p>
          <p className="c40 c87">
            <span className="c10">What personal information do we process? </span>
            <span className="c8">
              When you visit, use, or navigate our Services, we may process personal information depending on how you
              interact with us and the Services, the choices you make, and the products and features you use. Learn more
              about{' '}
            </span>
            <span className="c29">personal information you disclose to us</span>
            <span className="c8">. </span>
          </p>
          <p className="c40 c174">
            <span className="c10">Do we process any sensitive personal information? </span>
            <span className="c8">
              We may process sensitive personal information when necessary with your consent or as otherwise permitted
              by applicable law. Learn more about{' '}
            </span>
            <span className="c29">sensitive information we process</span>
            <span className="c8">. </span>
          </p>
          <p className="c40 c148">
            <span className="c10">Do we collect any information from third parties? </span>
            <span className="c8">
              We may collect information from public databases, marketing partners, social media platforms, and other
              outside sources. Learn more about{' '}
            </span>
            <span className="c29">information collected from other sources</span>
            <span className="c8">. </span>
          </p>
          <p className="c1 c138">
            <span className="c10">How do we process your information? </span>
            <span className="c8">
              We process your information to provide, improve, and administer our Services, communicate with you, for
              security and fraud prevention, and to comply with law. We may also process your information for other
              purposes with your consent. We process your information only when we have a valid legal reason to do so.
              Learn more about{' '}
            </span>
            <span className="c29">how we process your information</span>
            <span className="c8">. </span>
          </p>
          <p className="c114 c133">
            <span className="c10">In what situations and with which parties do we share personal information? </span>
            <span className="c8">
              We may share information in specific situations and with specific third parties. Learn more about{' '}
            </span>
            <span className="c29">when and with whom we share your personal information</span>
            <span className="c8">. </span>
          </p>
          <p className="c83">
            <span className="c10">How do we keep your information safe? </span>
            <span className="c8">
              We have organizational and technical processes and procedures in place to protect your personal
              information. However, no electronic transmission over the internet or information storage technology can
              be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other
              unauthorized third parties will not be able to defeat our security and improperly collect, access, steal,
              or modify your information. Learn more about{' '}
            </span>
            <span className="c29">how we keep your information safe</span>
            <span className="c8">. </span>
          </p>
          <p className="c85">
            <span className="c10">What are your rights? </span>
            <span className="c8">
              Depending on where you are located geographically, the applicable privacy law may mean you have certain
              rights regarding your personal information. Learn more about{' '}
            </span>
            <span className="c29">your privacy rights</span>
            <span className="c8">. </span>
          </p>
          <p className="c40 c107">
            <span className="c10">How do you exercise your rights? </span>
            <span className="c8">The easiest way to exercise your rights is by submitting a </span>
            <span className="c29">data subject access request</span>
            <span className="c8">
              , or by contacting us. We will consider and act upon any request in accordance with applicable data
              protection laws.
            </span>
          </p>
          <p className="c1">
            <span className="c8">Want to learn more about what we do with any information we collect? </span>
            <span className="c29">Review the privacy notice in full</span>
            <span className="c8">. </span>
          </p>
          <p className="c89">
            <span className="c0">TABLE OF CONTENTS </span>
          </p>
          <p className="c115 c142">
            <span className="c29">1. WHAT INFORMATION DO WE COLLECT? </span>
          </p>
          <p className="c88">
            <span className="c29">2. HOW DO WE PROCESS YOUR INFORMATION? </span>
          </p>
          <p className="c43">
            <span className="c29">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?</span>
          </p>
          <p className="c120">
            <span className="c29">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
          </p>
          <p className="c43">
            <span className="c29">5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span>
          </p>
          <p className="c67">
            <span className="c29">6. HOW DO WE HANDLE YOUR SOCIAL LOGINS? </span>
          </p>
          <p className="c43">
            <span className="c29">7. HOW LONG DO WE KEEP YOUR INFORMATION? </span>
          </p>
          <p className="c67">
            <span className="c29">8. HOW DO WE KEEP YOUR INFORMATION SAFE? </span>
          </p>
          <p className="c43">
            <span className="c29">9. DO WE COLLECT INFORMATION FROM MINORS? </span>
          </p>
          <p className="c71">
            <span className="c29">10. WHAT ARE YOUR PRIVACY RIGHTS? </span>
          </p>
          <p className="c140">
            <span className="c29">11. CONTROLS FOR DO-NOT-TRACK FEATURES </span>
          </p>
          <p className="c71">
            <span className="c29">12. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span>
          </p>
          <p className="c140">
            <span className="c29">13. DO WE MAKE UPDATES TO THIS NOTICE? </span>
          </p>
          <p className="c140">
            <span className="c29">14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE? </span>
          </p>
          <p className="c106">
            <span className="c29">15. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span>
          </p>
          <p className="c22 c45 c47">
            <span className="c0"></span>
          </p>
          <p className="c22 c45">
            <span className="c0">1. WHAT INFORMATION DO WE COLLECT? </span>
          </p>
          <p className="c115 c98">
            <span className="c32">Personal information you disclose to us </span>
          </p>
          <p className="c97 c161">
            <span className="c4">In Short: </span>
            <span className="c6">We collect personal information that you provide to us.</span>
          </p>
          <p className="c76">
            <span className="c8">
              We collect personal information that you voluntarily provide to us when you register on the Services,
              express an interest in obtaining information about us or our products and Services, when you participate
              in activities on the Services, or otherwise when you contact us.
            </span>
          </p>
          <p className="c136">
            <span className="c10">Personal Information Provided by You. </span>
            <span className="c8">
              The personal information that we collect depends on the context of your interactions with us and the
              Services, the choices you make, and the products and features you use. The personal information we collect
              may include the following:
            </span>
          </p>
          <ul className="c18 lst-kix_6r4zzw9px3kl-0 start">
            <li className="c37 li-bullet-0">
              <span className="c8">names </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">phone numbers </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">email addresses </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">mailing addresses </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">passwords </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">contact preferences </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">contact or authentication data </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">billing addresses </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">debit/credit card numbers </span>
            </li>
          </ul>
          <p className="c70">
            <span className="c10">Sensitive Information. </span>
            <span className="c8">
              When necessary, with your consent or as otherwise permitted by applicable law, we process the following
              categories of
            </span>
          </p>
          <ul className="c18 lst-kix_6kig78gzx5ov-0 start">
            <li className="c53 c72 li-bullet-0">
              <span className="c8">sensitive information: health data </span>
            </li>
            <li className="c53 c60 li-bullet-0">
              <span className="c8">financial data </span>
            </li>
            <li className="c24 c53 li-bullet-0">
              <span className="c8">social security numbers or other government identifiers</span>
            </li>
          </ul>
          <p className="c48 break-words">
            <span className="c10">Payment Data. </span>
            <span className="c8">
              We may collect data necessary to process your payment if you choose to make purchases, such as your
              payment instrument number, and the security code associated with your payment instrument. All payment data
              is handled and stored by{' '}
            </span>
            <span className="c34">Stripe</span>
            <span className="c8">
              . You may find their privacy notice link(s) here:{' '}
              <a href="https://stripe.com/privacy">https://stripe.com/privacy</a>.
            </span>
          </p>
          <p className="c40 c127">
            <span className="c10">Social Media Login Data. </span>
            <span className="c8">
              We may provide you with the option to register with us using your existing social media account details,
              like your Facebook, X, or other social media account. If you choose to register in this way, we will
              collect certain profile information about you from the social media provider, as described in the section
              called &quot;HOW DO WE HANDLE YOUR SOCIAL LOGINS?&quot; below.
            </span>
          </p>
          <p className="c77 c121">
            <span className="c10">Application Data. </span>
            <span className="c8">
              If you use our application(s), we also may collect the following information if you choose to provide us
              with access or permission:
            </span>
          </p>
          <ul className="c18 lst-kix_ppc6rc1uid22-0 start">
            <li className="c24 c53 c134 li-bullet-0">
              <span className="c6">Mobile Device Access. </span>
              <span className="c8">
                We may request access or permission to certain features from your mobile device, including your mobile
                device&#39;s camera, sms messages, storage, and other features. If you wish to change our access or
                permissions, you may do so in your device&#39;s settings.
              </span>
            </li>
            <li className="c12 c173 li-bullet-0">
              <span className="c6">Mobile Device Data. </span>
              <span className="c8">
                We automatically collect device information (such as your mobile device ID, model, and manufacturer),
                operating system, version information and system configuration information, device and application
                identification numbers, browser type and version, hardware model Internet service provider and/or mobile
                carrier, and Internet Protocol (IP) address (or proxy server). If you are using our application(s), we
                may also collect information about the phone network associated with your mobile device, your mobile
                device&rsquo;s operating system or platform, the type of mobile device you use, your mobile
                device&rsquo;s unique device ID, and information about the features of our application(s) you accessed.
              </span>
            </li>
            <li className="c12 c162 li-bullet-0">
              <span className="c6">Push Notifications. </span>
              <span className="c8">
                We may request to send you push notifications regarding your account or certain features of the
                application(s). If you wish to opt out from receiving these types of communications, you may turn them
                off in your device&#39;s settings.
              </span>
            </li>
          </ul>
          <p className="c110 c77 c168">
            <span className="c8">
              This information is primarily needed to maintain the security and operation of our application(s), for
              troubleshooting, and for our internal analytics and reporting purposes. All personal information that you
              provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal
              information.{' '}
            </span>
          </p>
          <p className="c32">Information automatically collected </p>
          <p className="c97 c155">
            <span className="c4">In Short: </span>
            <span className="c6">
              Some information &mdash; such as your Internet Protocol (IP) address and/or browser and device
              characteristics &mdash; is collected automatically when you visit our Services.
            </span>
          </p>
          <p className="c97 c118">
            <span className="c8">
              We automatically collect certain information when you visit, use, or navigate the Services. This
              information does not reveal your specific identity (like your name or contact information) but may include
              device and usage information, such as your IP address, browser and device characteristics, operating
              system, language preferences, referring URLs, device name, country, location, information about how and
              when you use our Services, and other technical information. This information is primarily needed to
              maintain the security and operation of our Services, and for our internal analytics and reporting
              purposes.
            </span>
          </p>
          <p className="c92">
            <span className="c8">
              Like many businesses, we also collect information through cookies and similar technologies.
            </span>
          </p>
          <p className="c68 c97">
            <span className="c8">The information we collect includes: </span>
          </p>
          <ul className="c18 lst-kix_ocu10zvo8p8u-0 start">
            <li className="c53 c129 li-bullet-0">
              <span className="c6">Log and Usage Data. </span>
              <span className="c8">
                Log and usage data is service-related, diagnostic, usage, and performance information our servers
                automatically collect when you access or use our Services and which we record in log files. Depending on
                how you interact with us, this log data may include your IP address, device information, browser type,
                and settings and
              </span>
              <span className="c34">&nbsp;</span>
              <span className="c8">
                information about your activity in the Services (such as the date/time stamps associated with your
                usage, pages and files viewed, searches, and other actions you take such as which features you use),
                device event information (such as system activity, error reports (sometimes called &quot;crash
                dumps&quot;), and hardware settings).
              </span>
            </li>
            <li className="c12 c150 li-bullet-0">
              <span className="c6">Device Data. </span>
              <span className="c8">
                We collect device data such as information about your computer, phone, tablet, or other device you use
                to access the Services. Depending on the device used, this device data may include information such as
                your IP address (or proxy server), device and application identification numbers, location, browser
                type, hardware model, Internet service provider and/or mobile carrier, operating system, and system
                configuration information.
              </span>
            </li>
          </ul>
          <p className="c52">
            <span className="c32">Information collected from other sources </span>
          </p>
          <p className="c109 c97">
            <span className="c4">In Short: </span>
            <span className="c6">
              We may collect limited data from public databases, marketing partners, social media platforms, and other
              outside sources.
            </span>
          </p>
          <p className="c35">
            <span className="c8">
              In order to enhance our ability to provide relevant marketing, offers, and services to you and update our
              records, we may obtain information about you from other sources, such as public databases, joint marketing
              partners, affiliate programs, data providers, social media platforms, and from other third parties. This
              information includes mailing addresses, job titles, email addresses, phone numbers, intent data (or user
              behavior data), Internet Protocol (IP) addresses, social media profiles, social media URLs, and custom
              profiles, for purposes of targeted advertising and event promotion.
            </span>
          </p>
          <p className="c105">
            <span className="c8">
              If you interact with us on a social media platform using your social media account (e.g., Facebook or X),
              we receive personal information about you from such platforms such as your name, email address, and
              gender. Any personal information that we collect from your social media account depends on your social
              media account&#39;s privacy settings. Please note that their own use of your information is not governed
              by this privacy notice.
            </span>
          </p>
          <p className="c97 c151">
            <span className="c0">2. HOW DO WE PROCESS YOUR INFORMATION? </span>
          </p>
          <p className="c30">
            <span className="c4">In Short: </span>
            <span className="c6">
              We process your information to provide, improve, and administer our Services, communicate with you, for
              security and fraud prevention, and to comply with law. We may also process your information for other
              purposes with your consent.
            </span>
          </p>
          <p className="c40 c77">
            <span className="c10">
              We process your personal information for a variety of reasons, depending on how you interact with our
              Services, including:
            </span>
          </p>
          <ul className="c18 lst-kix_3ka8dh716nsp-0 start">
            <li className="c53 c113 li-bullet-0">
              <span className="c10">
                To facilitate account creation and authentication and otherwise manage user accounts.{' '}
              </span>
              <span className="c8">
                We may process your information so you can create and log in to your account, as well as keep your
                account in working order.
              </span>
            </li>
            <li className="c12 li-bullet-0">
              <span className="c10">To deliver and facilitate delivery of services to the user. </span>
              <span className="c8">We may process your information to provide you with the requested service.</span>
            </li>
            <li className="c3 li-bullet-0">
              <span className="c10">To respond to user inquiries/offer support to users. </span>
              <span className="c8">
                We may process your information to respond to your inquiries and solve any potential issues you might
                have with the requested service.
              </span>
            </li>
            <li className="c37 c177 li-bullet-0">
              <span className="c10">To fulfill and manage your orders. </span>
              <span className="c8">
                We may process your information to fulfill and manage your orders, payments, returns, and exchanges made
                through the Services.{' '}
              </span>
              <span className="c10">To request feedback. </span>
              <span className="c8">
                We may process your information when necessary to request feedback and to contact you about your use of
                our Services.
              </span>
            </li>
            <li className="c53 c143 li-bullet-0">
              <span className="c10">To send you marketing and promotional communications. </span>
              <span className="c8">
                We may process the personal information you send to us for our marketing purposes, if this is in
                accordance with your marketing preferences. You can opt out of our marketing emails at any time. For
                more information, see &quot;
              </span>
              <span className="c29">WHAT ARE YOUR PRIVACY RIGHTS?</span>
              <span className="c8">&quot; below. </span>
            </li>
            <li className="c12 c128 li-bullet-0">
              <span className="c10">To deliver targeted advertising to you. </span>
              <span className="c8">
                We may process your information to develop and display personalized content and advertising tailored to
                your interests, location, and more.
              </span>
            </li>
            <li className="c12 c81 li-bullet-0">
              <span className="c10">To protect our Services. </span>
              <span className="c8">
                We may process your information as part of our efforts to keep our Services safe and secure, including
                fraud monitoring and prevention.{' '}
              </span>
              <span className="c10">To identify usage trends. </span>
              <span className="c8">
                We may process information about how you use our Services to better understand how they are being used
                so we can improve them.
              </span>
            </li>
            <li className="c60 c53 c157 li-bullet-0">
              <span className="c10">To determine the effectiveness of our marketing and promotional campaigns. </span>
              <span className="c8">
                We may process your information to better understand how to provide marketing and promotional campaigns
                that are most relevant to you.
              </span>
            </li>
            <li className="c12 c122 li-bullet-0">
              <span className="c10">To save or protect an individual&#39;s vital interest. </span>
              <span className="c8">
                We may process your information when necessary to save or protect an individual&rsquo;s vital interest,
                such as to
              </span>
              <span className="c34">&nbsp;</span>
              <span className="c8">prevent harm. </span>
            </li>
          </ul>
          <p className="c36">
            <span className="c0">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</span>
          </p>
          <p className="c82">
            <span className="c4">In Short: </span>
            <span className="c6">
              We only process your personal information when we believe it is necessary and we have a valid legal reason
              (i.e., legal basis) to do so under applicable law, like with your consent, to comply with laws, to provide
              you with services to enter into or fulfill our contractual obligations, to protect your rights, or to
              fulfill our legitimate business interests.
            </span>
          </p>
          <p className="c40 c97">
            <span className="c17">If you are located in the EU or UK, this section applies to you.</span>
            <span className="c4">&nbsp;</span>
          </p>
          <p className="c166">
            <span className="c8">
              The General Data Protection Regulation (GDPR) and UK GDPR require us to explain the valid legal bases we
              rely on in order to process your personal information. As such, we may rely on the following legal bases
              to process your personal information:
            </span>
          </p>
          <ul className="c18 lst-kix_m8xo19m609kp-0 start">
            <li className="c5 li-bullet-0">
              <span className="c10">Consent. </span>
              <span className="c8">
                We may process your information if you have given us permission (i.e., consent) to use your personal
                information for a specific purpose. You can withdraw your consent at any time. Learn more about{' '}
              </span>
              <span className="c29">withdrawing your consent</span>
              <span className="c8">. </span>
            </li>
            <li className="c12 c116 li-bullet-0">
              <span className="c10">Performance of a Contract. </span>
              <span className="c8">
                We may process your personal information when we believe it is necessary to fulfill our contractual
                obligations to you, including providing our Services or at your request prior to entering into a
                contract with you.
              </span>
            </li>
            <li className="c12 c130 li-bullet-0">
              <span className="c10">Legitimate Interests. </span>
              <span className="c8">
                We may process your information when we believe it is reasonably necessary to achieve our legitimate
                business interests and those interests do not outweigh your interests and fundamental rights and
                freedoms. For example, we may process your personal information for some of the purposes described in
                order to:
              </span>
            </li>
          </ul>
          <ul className="c18 lst-kix_m8xo19m609kp-1 start">
            <li className="c7 li-bullet-0">
              <span className="c8">
                Send users information about special offers and discounts on our products and services
              </span>
            </li>
            <li className="c24 c50 li-bullet-0">
              <span className="c8">
                Develop and display personalized and relevant advertising content for our users
              </span>
            </li>
            <li className="c22 c50 li-bullet-0">
              <span className="c8">
                Analyze how our Services are used so we can improve them to engage and retain users
              </span>
            </li>
            <li className="c24 c50 li-bullet-0">
              <span className="c8">Support our marketing activities </span>
            </li>
            <li className="c24 c50 li-bullet-0">
              <span className="c8">Diagnose problems and/or prevent fraudulent activities</span>
            </li>
            <li className="c24 c50 li-bullet-0">
              <span className="c8">
                Understand how our users use our products and services so we can improve user experience
              </span>
            </li>
          </ul>
          <ul className="c18 lst-kix_m8xo19m609kp-0">
            <li className="c24 c53 c153 li-bullet-0">
              <span className="c10">Legal Obligations. </span>
              <span className="c8">
                We may process your information where we believe it is necessary for compliance with our legal
                obligations, such as to cooperate with a law enforcement body or regulatory agency, exercise or defend
                our legal rights, or disclose your information as evidence in litigation in which we are involved.
              </span>
            </li>
            <li className="c12 c124 li-bullet-0">
              <span className="c10">Vital Interests. </span>
              <span className="c8">
                We may process your information where we believe it is necessary to protect your vital interests or the
                vital interests of a third party, such as situations involving potential threats to the safety of any
                person.
              </span>
            </li>
          </ul>
          <p className="c33">
            <span className="c17">If you are located in Canada, this section applies to you.</span>
            <span className="c4">&nbsp;</span>
          </p>
          <p className="c62">
            <span className="c8">
              We may process your information if you have given us specific permission (i.e., express consent) to use
              your personal information for a specific purpose, or in situations where your permission can be inferred
              (i.e., implied consent). You can{' '}
            </span>
            <span className="c29">withdraw your consent </span>
            <span className="c8">at any time. </span>
          </p>
          <p className="c149">
            <span className="c8">
              In some exceptional cases, we may be legally permitted under applicable law to process your information
              without your consent, including, for example:
            </span>
          </p>
          <p className="c60 c42">
            <span className="c8">
              {' '}
              If collection is clearly in the interests of an individual and consent cannot be obtained in a timely way
            </span>
          </p>

          <p className="c60 c42">
            <span className="c8">For investigations and fraud detection and prevention</span>
          </p>
          <p className="c24 c42">
            <span className="c8">For business transactions provided certain conditions are met</span>
          </p>
          <p className="c24 c42">
            <span className="c8">
              If it is contained in a witness statement and the collection is necessary to assess, process, or settle an
              insurance claim
            </span>
          </p>
          <p className="c24 c42">
            <span className="c8">
              For identifying injured, ill, or deceased persons and communicating with next of kin
            </span>
          </p>
          <p className="c24 c42">
            <span className="c8">
              If we have reasonable grounds to believe an individual has been, is, or may be victim of financial abuse
            </span>
          </p>
          <p className="c24 c102">
            <span className="c8">
              If it is reasonable to expect collection and use with consent would compromise the availability or the
              accuracy of the information and the collection is reasonable for purposes related to investigating a
              breach of an agreement or a contravention of the laws of Canada or a province
            </span>
          </p>
          <p className="c94 c42">
            <span className="c8">
              If disclosure is required to comply with a subpoena, warrant, court order, or rules of the court relating
              to the production of records
            </span>
          </p>
          <p className="c24 c103 c170">
            <span className="c8">
              If it was produced by an individual in the course of their employment, business, or profession and the
              collection is consistent with the purposes for which the information was produced
            </span>
          </p>
          <p className="c42 c94">
            <span className="c8">If the collection is solely for journalistic, artistic, or literary purposes</span>
          </p>
          <p className="c24 c42">
            <span className="c8">If the information is publicly available and is specified by the regulations</span>
          </p>
          <p className="c97 c159">
            <span className="c0">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
          </p>
          <p className="c14">
            <span className="c4">In Short: </span>
            <span className="c6">
              We may share information in specific situations described in this section and/or with the following third
              parties.
            </span>
          </p>
          <p className="c39">
            <span className="c8">We may need to share your personal information in the following situations:</span>
          </p>
          <p className="c144">
            <span className="c10">Business Transfers. </span>
            <span className="c8">
              We may share or transfer your information in connection with, or during negotiations of, any merger, sale
              of company assets, financing, or acquisition of all or a portion of our business to another company.
            </span>
          </p>
          <p className="c90">
            <span className="c10">Affiliates. </span>
            <span className="c8">
              We may share your information with our affiliates, in which case we will require those affiliates to honor
              this privacy notice. Affiliates include our parent company and any subsidiaries, joint venture partners,
              or other companies that we control or that are under common control with us.
            </span>
          </p>
          <p className="c64">
            <span className="c10">Business Partners. </span>
            <span className="c8">
              We may share your information with our business partners to offer you certain products, services, or
              promotions.
            </span>
          </p>
          <p className="c36">
            <span className="c0">5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span>
          </p>
          <p className="c97 c115">
            <span className="c4">In Short: </span>
            <span className="c6">
              We may use cookies and other tracking technologies to collect and store your information.
            </span>
          </p>
          <p className="c84 c86">
            <span className="c8">
              We may use cookies and similar tracking technologies (like web beacons and pixels) to gather information
              when you interact with our Services. Some online tracking technologies help us maintain the security of
              our Services and your account, prevent crashes, fix bugs, save your preferences, and assist with basic
              site functions.
            </span>
          </p>
          <p className="c137 c169">
            <span className="c8">
              We also permit third parties and service providers to use online tracking technologies on our Services for
              analytics and advertising, including to help manage and display advertisements, to tailor advertisements
              to your interests, or to send abandoned shopping cart reminders (depending on your communication
              preferences). The third parties and service providers use their technology to provide advertising about
              products and services tailored to your interests which may appear either on our Services or on other
              websites.
            </span>
          </p>
          <p className="c16">
            <span className="c8">
              To the extent these online tracking technologies are deemed to be a &quot;sale&quot;/&quot;sharing&quot;
              (which includes targeted advertising, as defined under the applicable laws) under applicable US state
              laws, you can opt out of these online tracking technologies by submitting a request as described below
              under section &quot;
            </span>
            <span className="c29">DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span>
            <span className="c8">&quot; </span>
          </p>
          <p className="c22 c47 c78">
            <span className="c8"></span>
          </p>
          <p className="c22 c78">
            <span className="c8">
              We may share your information with Google Analytics to track and analyze the use of the Services. To opt
              out of being tracked by Google Analytics across the Services, visit{' '}
              <a className="break-words" href="https://tools.google.com/dlpage/gaoptout">
                https://tools.google.com/dlpage/gaoptout
              </a>
              . For more information on the privacy practices of Google, please visit the{' '}
            </span>
            <span className="c29">Google Privacy &amp; Terms page</span>
            <span className="c8">. </span>
          </p>
          <p className="c2 c84">
            <span className="c0">6. HOW DO WE HANDLE YOUR SOCIAL LOGINS? </span>
          </p>
          <p className="c14">
            <span className="c4">In Short: </span>
            <span className="c6">
              If you choose to register or log in to our Services using a social media account, we may have access to
              certain information about you.
            </span>
          </p>
          <p className="c68 c137 c154">
            <span className="c8">
              Our Services offer you the ability to register and log in using your third-party social media account
              details (like your Facebook or X logins). Where you choose to do this, we will receive certain profile
              information about you from your social media provider. The profile information we receive may vary
              depending on the social media provider concerned, but will often include your name, email address, friends
              list, and profile picture, as well as other information you choose to make public on such a social media
              platform.
            </span>
          </p>
          <p className="c46">
            <span className="c8">
              We will use the information we receive only for the purposes that are described in this privacy notice or
              that are otherwise made clear to you on the relevant Services. Please note that we do not control, and are
              not responsible for, other uses of your personal information by your third-party social media provider. We
              recommend that you review their privacy notice to understand how they collect, use, and share your
              personal information, and how you can set your privacy preferences on their sites and apps.
            </span>
          </p>
          <p className="c59 c84">
            <span className="c0">7. HOW LONG DO WE KEEP YOUR INFORMATION? </span>
          </p>
          <p className="c14">
            <span className="c4">In Short: </span>
            <span className="c6">
              We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice
              unless otherwise required by law.
            </span>
          </p>
          <p className="c68 c104">
            <span className="c8">
              We will only keep your personal information for as long as it is necessary for the purposes set out in
              this privacy notice, unless a longer retention period is required or permitted by law (such as tax,
              accounting, or other legal requirements). No purpose in this notice will require us keeping your personal
              information for longer than the period of time in which users have an account with us.
            </span>
          </p>
          <p className="c80">
            <span className="c8">
              When we have no ongoing legitimate business need to process your personal information, we will either
              delete or anonymize such information, or, if this is not possible (for example, because your personal
              information has been stored in backup archives), then we will securely store your personal information and
              isolate it from any further processing until deletion is possible.
            </span>
          </p>
          <p className="c59 c84">
            <span className="c0">8. HOW DO WE KEEP YOUR INFORMATION SAFE? </span>
          </p>
          <p className="c14">
            <span className="c4">In Short: </span>
            <span className="c6">
              We aim to protect your personal information through a system of organizational and technical security
              measures.
            </span>
          </p>
          <p className="c54">
            <span className="c8">
              We have implemented appropriate and reasonable technical and organizational security measures designed to
              protect the security of any personal information we process. However, despite our safeguards and efforts
              to secure your information, no electronic transmission over the Internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or
              other unauthorized third parties will not be able to defeat our security and improperly collect, access,
              steal, or modify your information. Although we will do our best to protect your personal information,
              transmission of personal information to and from our Services is at your own risk. You should only access
              the Services within a secure environment.
            </span>
          </p>
          <p className="c121 c137">
            <span className="c0">9. DO WE COLLECT INFORMATION FROM MINORS? </span>
          </p>
          <p className="c115 c97">
            <span className="c4">In Short: </span>
            <span className="c6">
              We do not knowingly collect data from or market to children under 18 years of age.
            </span>
          </p>
          <p className="c141">
            <span className="c8">
              We do not knowingly collect, solicit data from, or market to children under 18 years of age, nor do we
              knowingly sell such personal information. By using the Services, you represent that you are at least 18 or
              that you are the parent or guardian of such a minor and consent to such minor dependent&rsquo;s use of the
              Services. If we learn that personal information from users less than 18 years of age has been collected,
              we will deactivate the account and take reasonable measures to promptly delete such data from our records.
              If you become aware of any data we may have collected from children under age 18, please contact us at{' '}
            </span>
            <span className="c34">support@provenvalor.com</span>
            <span className="c8">. </span>
          </p>
          <p className="c121 c45">
            <span className="c0">10. WHAT ARE YOUR PRIVACY RIGHTS? </span>
          </p>
          <p className="c115 c97 c179">
            <span className="c4">In Short: </span>
            <span className="c6">
              Depending on your state of residence in the US or in some regions, such as the European Economic Area
              (EEA), United Kingdom (UK), Switzerland, and Canada, you have rights that allow you greater access to and
              control over your personal information. You may review, change, or terminate your account at any time,
              depending on your country, province, or state of residence.
            </span>
          </p>
          <p className="c75">
            <span className="c8">
              In some regions (like the EEA, UK, Switzerland, and Canada), you have certain rights under applicable data
              protection laws. These may include the right (i) to request access and obtain a copy of your personal
              information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal
              information; (iv) if applicable, to data portability; and (v) not to be subject to automated
              decision-making. In certain circumstances, you may also have the right to object to the processing of your
              personal information. You can make such a request by contacting us by using the contact details provided
              in the section &quot;
            </span>
            <span className="c29">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
            <span className="c8">&quot; below. </span>
          </p>
          <p className="c56">
            <span className="c8">
              We will consider and act upon any request in accordance with applicable data protection laws.
            </span>
          </p>
          <p className="c99">
            <span className="c8">
              If you are located in the EEA or UK and you believe we are unlawfully processing your personal
              information, you also have the right to complain to your{' '}
            </span>
            <span className="c29">Member State data protection authority </span>
            <span className="c8">or </span>
            <span className="c29">UK data protection authority</span>
            <span className="c8">. </span>
          </p>
          <p className="c93">
            <span className="c8">If you are located in Switzerland, you may contact the </span>
            <span className="c29">Federal Data Protection and Information Commissioner</span>
            <span className="c8">. </span>
          </p>
          <p className="c9">
            <span className="c20">Withdrawing your consent: </span>
            <span className="c8">
              If we are relying on your consent to process your personal information, which may be express and/or
              implied consent depending on the applicable law, you have the right to withdraw your consent at any time.
              You can withdraw your consent at any time by contacting us by using the contact details provided in the
              section &quot;
            </span>
            <span className="c29">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
            <span className="c8">&quot; below. </span>
          </p>
          <p className="c49">
            <span className="c8">
              However, please note that this will not affect the lawfulness of the processing before its withdrawal nor,
              when applicable law allows, will it affect the processing of your personal information conducted in
              reliance on lawful processing grounds other than consent.
            </span>
          </p>
          <p className="c22 c132">
            <span className="c20">Opting out of marketing and promotional communications:</span>
            <span className="c10">&nbsp;</span>
            <span className="c8">
              You can unsubscribe from our marketing and promotional communications at any time by clicking on the
              unsubscribe link in the emails that we send, replying &quot;STOP&quot; or &quot;UNSUBSCRIBE&quot; to the
              SMS messages that we send, or by contacting us using the details provided in the section &quot;
            </span>
            <span className="c29">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
            <span className="c8">
              &quot; below. You will then be removed from the marketing lists. However, we may still communicate with
              you &mdash; for example, to send you service related messages that are necessary for the administration
              and use of your account, to respond to service requests, or for other non-marketing purposes.
            </span>
          </p>
          <p className="c77 c95">
            <span className="c32">Account Information </span>
          </p>
          <p className="c69 c98">
            <span className="c8">
              If you would at any time like to review or change the information in your account or terminate your
              account, you can:
            </span>
          </p>
          <p className="c24 c103">
            <span className="c8">Log in to your account settings and update your user account.</span>
          </p>
          <p className="c172 c175">
            <span className="c8">
              Upon your request to terminate your account, we will deactivate or delete your account and information
              from our active databases. However, we may retain some information in our files to prevent fraud,
              troubleshoot problems, assist with any investigations, enforce our legal terms and/or comply with
              applicable legal requirements.
            </span>
          </p>
          <p className="c111">
            <span className="c20">Cookies and similar technologies:</span>
            <span className="c10">&nbsp;</span>
            <span className="c8">
              Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your
              browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this
              could affect certain features or services of our Services.
            </span>
          </p>
          <p className="c45 c59">
            <span className="c0">11. CONTROLS FOR DO-NOT-TRACK FEATURES </span>
          </p>
          <p className="c108">
            <span className="c8">
              Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track
              (&quot;DNT&quot;) feature or setting you can activate to signal your privacy preference not to have data
              about your online browsing activities monitored and collected. At this stage, no uniform technology
              standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently
              respond to DNT browser signals or any other mechanism that automatically communicates your choice not to
              be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will
              inform you about that practice in a revised version of this privacy notice.
            </span>
          </p>
          <p className="c61 c97 c171">
            <span className="c8">
              California law requires us to let you know how we respond to web browser DNT signals. Because there
              currently is not an industry or legal standard for recognizing or honoring DNT signals, we do not respond
              to them at this time.
            </span>
          </p>
          <p className="c2 c45">
            <span className="c0">12. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span>
          </p>
          <p className="c14 c146">
            <span className="c4">In Short: </span>
            <span className="c6">
              If you are a resident of California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky,
              Montana, New Hampshire, New Jersey, Oregon, Tennessee, Texas, Utah, or Virginia, you may have the right to
              request access to and receive details about the personal information we maintain about you and how we have
              processed it, correct inaccuracies, get a copy of, or delete your personal information. You may also have
              the right to withdraw your consent to our processing of your personal information. These rights may be
              limited in some circumstances by applicable law. More information is provided below.
            </span>
          </p>
          <p className="c73">
            <span className="c32">Categories of Personal Information We Collect </span>
          </p>
          <p className="c31">
            <span className="c8">
              We have collected the following categories of personal information in the past twelve (12) months:
            </span>
          </p>
          <div className="overflow-auto">
            <table className="c156 table-auto">
              <tr className="c79">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c74">
                    <span className="c10">Category </span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c25">
                    <span className="c10">Examples </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c10">Collected</span>
                  </p>
                </td>
              </tr>
              <tr className="c167">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c165">
                    <span className="c8">A. Identifiers</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c11">
                    <span className="c8">
                      Contact details, such as real name, alias, postal address, telephone or mobile contact number,
                      unique personal identifier, online identifier, Internet Protocol address, email address, and
                      account name
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">YES</span>
                  </p>
                </td>
              </tr>
              <tr className="c131">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c163 c178">
                    <span className="c8">
                      B. Personal information as defined in the California Customer Records statute
                    </span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c25 c112">
                    <span className="c8">
                      Name, contact information, education, employment, employment history, and financial information
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">YES</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c117">
                    <span className="c8">C. Protected classification characteristics under state or federal law</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c160 c176">
                    <span className="c8">
                      Gender, age, date of birth, race and ethnicity, national origin, marital status, and other
                      demographic data
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">YES</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c57">
                    <span className="c8">D. Commercial information </span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c160">
                    <span className="c8">
                      Transaction information, purchase history, financial details, and payment information
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c100">
                    <span className="c8">E. Biometric information </span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c58">
                    <span className="c8">Fingerprints and voiceprints </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c100">
                    <span className="c8">F. Internet or other similar network activity</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c160 c164">
                    <span className="c8">
                      Browsing history, search history, online behavior, interest data, and interactions with our and
                      other websites, applications, systems, and advertisements
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c163">
                    <span className="c8">G. Geolocation data </span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c25">
                    <span className="c8">Device location </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c100">
                    <span className="c8">H. Audio, electronic, sensory, or similar information</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">
                      Images and audio, video or call recordings created in connection with our business activities
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c123">
                    <span className="c8">I. Professional or employment-related information</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c23">
                    <span className="c8">
                      Business contact details in order to provide you our Services at a business level or job title,
                      work history, and professional qualifications if you apply for a job with us
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">YES</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c22 c25">
                    <span className="c8">J. Education Information Student records and directory information</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c23 c47">
                    <span className="c8"></span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c34">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c61">
                    <span className="c8">K. Inferences drawn from collected personal information</span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c25 c66">
                    <span className="c8">
                      Inferences drawn from any of the collected personal information listed above to create a profile
                      or summary about, for example, an individual&rsquo;s preferences and characteristics
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">NO</span>
                  </p>
                </td>
              </tr>
              <tr className="c19">
                <td className="c15" colSpan={1} rowSpan={1}>
                  <p className="c61">
                    <span className="c8">L. Sensitive personal Information </span>
                  </p>
                </td>
                <td className="c26" colSpan={1} rowSpan={1}>
                  <p className="c22 c63">
                    <span className="c8">
                      Account login information, debit or credit card numbers, financial information including account
                      access details, health data, national origin and social security numbers
                    </span>
                  </p>
                </td>
                <td className="c13" colSpan={1} rowSpan={1}>
                  <p className="c22">
                    <span className="c8">YES</span>
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <p className="c22 c47">
            <span className="c125"></span>
          </p>
          <p className="c22">
            <span className="c8">
              We only collect sensitive personal information, as defined by applicable privacy laws or the purposes
              allowed by law or with your consent. Sensitive personal information may be used, or disclosed to a service
              provider or contractor, for additional, specified purposes. You may have the right to limit the use or
              disclosure of your sensitive personal information. We do not collect or process sensitive personal
              information for the purpose of inferring characteristics about you.
            </span>
          </p>
          <p className="c114">
            <span className="c8">
              We may also collect other personal information outside of these categories through instances where you
              interact with us in person, online, or by phone or mail in the context of: Receiving help through our
              customer support channels;
            </span>
          </p>
          <p className="c60">
            <span className="c8">Participation in customer surveys or contests; and</span>
          </p>
          <p className="c24">
            <span className="c8">Facilitation in the delivery of our Services and to respond to your inquiries.</span>
          </p>
          <p className="c24">
            <span className="c8">
              We will use and retain the collected personal information as needed to provide the Services or for:
            </span>
          </p>
          <p className="c24">
            <span className="c8">Category A - As long as the user has an account with us</span>
          </p>
          <p className="c24">
            <span className="c8">Category B - As long as the user has an account with us</span>
          </p>
          <p className="c24">
            <span className="c8">Category C - As long as the user has an account with us</span>
          </p>
          <p className="c24">
            <span className="c8">Category H - As long as the user has an account with us</span>
          </p>
          <p className="c24">
            <span className="c8">Category I - As long as the user has an account with us</span>
          </p>
          <p className="c24">
            <span className="c8">Category L - As long as the user has an account with us</span>
          </p>
          <p className="c24">
            <span className="c32">Sources of Personal Information </span>
          </p>
          <p className="c109">
            <span className="c8">Learn more about the sources of personal information we collect in &quot;</span>
            <span className="c29">WHAT INFORMATION DO WE COLLECT?</span>
            <span className="c8">&quot; </span>
          </p>
          <p className="c135">
            <span className="c32">How We Use and Share Personal Information </span>
          </p>
          <p className="c69">
            <span className="c8">Learn about how we use your personal information in the section, &quot;</span>
            <span className="c29">HOW DO WE PROCESS YOUR INFORMATION?</span>
            <span className="c8">&quot; </span>
          </p>
          <p className="c68">
            <span className="c10">Will your information be shared with anyone else?</span>
          </p>
          <p className="c68">
            <span className="c8">
              We may disclose your personal information with our service providers pursuant to a written contract
              between us and each service provider. Learn more about how we disclose personal information to in the
              section, &quot;
            </span>
            <span className="c29">WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
            <span className="c8">&quot; </span>
          </p>
          <p className="c40">
            <span className="c8">
              We may use your personal information for our own business purposes, such as for undertaking internal
              research for technological development and demonstration. This is not considered to be &quot;selling&quot;
              of your personal information.
            </span>
          </p>
          <p className="c40">
            <span className="c8">
              We have not disclosed, sold, or shared any personal information to third parties for a business or
              commercial purpose in the preceding twelve (12) months. We will not sell or share personal information in
              the future belonging to website visitors, users, and other consumers.
            </span>
          </p>
          <p className="c2">
            <span className="c32">Your Rights </span>
          </p>
          <p className="c55">
            <span className="c8">
              You have rights under certain US state data protection laws. However, these rights are not absolute, and
              in certain cases, we may decline your request as permitted by law. These rights include:
            </span>
          </p>
          <p className="c126">
            <span className="c10">Right to know </span>
            <span className="c8">whether or not we are processing your personal data</span>
          </p>
          <p className="c24">
            <span className="c10">Right to access </span>
            <span className="c8">your personal data </span>
          </p>
          <p className="c24">
            <span className="c10">Right to correct </span>
            <span className="c8">inaccuracies in your personal data </span>
          </p>
          <p className="c24">
            <span className="c10">Right to request </span>
            <span className="c8">the deletion of your personal data </span>
          </p>
          <p className="c24">
            <span className="c10">Right to obtain a copy </span>
            <span className="c8">of the personal data you previously shared with us</span>
          </p>
          <p className="c24">
            <span className="c10">Right to non-discrimination </span>
            <span className="c8">for exercising your rights </span>
          </p>
          <p className="c24">
            <span className="c10">Right to opt out </span>
            <span className="c8">
              of the processing of your personal data if it is used for targeted advertising (or sharing as defined
              under California&rsquo;s privacy law), the sale of personal data, or profiling in furtherance of decisions
              that produce legal or similarly significant effects (&quot;profiling&quot;)
            </span>
          </p>
          <p className="c110">
            <span className="c8">Depending upon the state where you live, you may also have the following rights:</span>
          </p>
          <p className="c172">
            <span className="c8">
              Right to obtain a list of the categories of third parties to which we have disclosed personal data (as
              permitted by applicable law, including California&#39;s and Delaware&#39;s privacy law) Right to obtain a
              list of specific third parties to which we have disclosed personal data (as permitted by applicable law,
              including Oregon&rsquo;s privacy law) Right to limit use and disclosure of sensitive personal data (as
              permitted by applicable law, including California&rsquo;s privacy law)
            </span>
          </p>
          <p className="c22 c28">
            <span className="c8">
              Right to opt out of the collection of sensitive data and personal data collected through the operation of
              a voice or facial recognition feature (as permitted by applicable law, including Florida&rsquo;s privacy
              law)
            </span>
          </p>
          <p className="c52">
            <span className="c32">How to Exercise Your Rights </span>
          </p>
          <p className="c97 c109">
            <span className="c8">To exercise these rights, you can contact us by submitting a </span>
            <span className="c29">data subject access request</span>
            <span className="c8">, or by referring to the contact details at the bottom of this document.</span>
          </p>
          <p className="c21">
            <span className="c8">
              Under certain US state data protection laws, you can designate an authorized agent to make a request on
              your behalf. We may deny a request from an authorized agent that does not submit proof that they have been
              validly authorized to act on your behalf in accordance with applicable laws.
            </span>
          </p>
          <p className="c2 c98">
            <span className="c32">Request Verification </span>
          </p>
          <p className="c55 c152">
            <span className="c8">
              Upon receiving your request, we will need to verify your identity to determine you are the same person
              about whom we have the information in our system. We will only use personal information provided in your
              request to verify your identity or authority to make the request. However, if we cannot verify your
              identity from the information already maintained by us, we may request that you provide additional
              information for the purposes of verifying your identity and for security or fraud-prevention purposes.
            </span>
          </p>
          <p className="c44">
            <span className="c8">
              If you submit the request through an authorized agent, we may need to collect additional information to
              verify your identity before processing your request and the agent will need to provide a written and
              signed permission from you to submit such request on your behalf.
            </span>
          </p>
          <p className="c65">
            <span className="c32">Appeals </span>
          </p>
          <p className="c55 c77 c145">
            <span className="c8">
              Under certain US state data protection laws, if we decline to take action regarding your request, you may
              appeal our decision by emailing us at support@provenvalor.com. We will inform you in writing of any action
              taken or not taken in response to the appeal, including a written explanation of the reasons for the
              decisions. If your appeal is denied, you may submit a complaint to your state attorney general.
            </span>
          </p>
          <p className="c114 c84">
            <span className="c32">California &quot;Shine The Light&quot; Law </span>
          </p>
          <p className="c55 c77 c101">
            <span className="c8">
              California Civil Code Section 1798.83, also known as the &quot;Shine The Light&quot; law, permits our
              users who are California residents to request and obtain from us, once a year and free of charge,
              information about categories of personal information (if any) we disclosed to third parties for direct
              marketing purposes and the names and addresses of all third parties with which we shared personal
              information in the immediately preceding calendar year. If you are a California resident and would like to
              make such a request, please submit your request in writing to us by using the contact details provided in
              the section &quot;
            </span>
            <span className="c29">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
            <span className="c8">&quot; </span>
          </p>
          <p className="c121 c45">
            <span className="c0">13. DO WE MAKE UPDATES TO THIS NOTICE? </span>
          </p>
          <p className="c115 c97">
            <span className="c4">In Short: </span>
            <span className="c6">
              Yes, we will update this notice as necessary to stay compliant with relevant laws.
            </span>
          </p>
          <p className="c139">
            <span className="c8">
              We may update this privacy notice from time to time. The updated version will be indicated by an updated
              &quot;Revised&quot; date at the top of this privacy notice. If we make material changes to this privacy
              notice, we may notify you either by prominently posting a notice of such changes or by directly sending
              you a notification. We encourage you to review this privacy notice frequently to be informed of how we are
              protecting your information.
            </span>
          </p>
          <p className="c59 c45">
            <span className="c0">14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE? </span>
          </p>
          <p className="c98 c147">
            <span className="c8">If you have questions or comments about this notice, you may contact us at: </span>
            <span className="c34">support@provenvalor.com</span>
          </p>
          <p className="c27">
            <span className="c0">15. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span>
          </p>
          <p className="c115 c77 c119">
            <span className="c8">
              You have the right to request access to the personal information we collect from you, details about how we
              have processed it, correct inaccuracies, or delete your personal information. You may also have the right
              to withdraw your consent to our processing of your personal information. These rights may be limited in
              some circumstances by applicable law. To request to review, update, or delete your personal information,
              please fill out and submit a{' '}
            </span>
            <span className="c29">data subject access request</span>
            <span className="c8">.</span>
          </p>
        </Box>
      </div>
    </main>
  );
}
